import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormInput, FormButton, Margin, Text } from 'shared/components'

import * as styles from './styles'

const ConfirmFormComponent = ({ form, onSubmit }) => (
  <Form form={form} onSubmit={onSubmit} css={styles.form}>
    <Margin bottom={1}>
      <FormInput
        name="email"
        label="Email"
        type="email"
        placeholder="account@email.com"
        strictLong
      />
    </Margin>
    <Margin bottom={1}>
      <FormInput
        name="password"
        label="Password"
        type="password"
        placeholder="********"
        strictLong
      />
    </Margin>
    <Margin bottom={1}>
      <FormInput
        name="confirmation"
        label="Confirmation"
        type="password"
        placeholder="********"
        strictLong
      />
    </Margin>
    <Margin top={2} css={styles.buttonContainer}>
      <FormButton submit medium green css={styles.confirmButton}>
        <Text size={16} upper bold>
          Confirm
        </Text>
      </FormButton>
    </Margin>
  </Form>
)

ConfirmFormComponent.propTypes = {
  form: PropTypes.shape(),
  onSubmit: PropTypes.func,
}

export default ConfirmFormComponent
